// extracted by mini-css-extract-plugin
module.exports = {"pwabutton":"pwabutton_pwabutton__yqmB5"};